/* eslint-disable camelcase */
import en_US from './en.json';
import de_DE from './de.json';

export default {
  en: en_US,
  de: de_DE,
};
